import React from "react";
import FormattedDate from "../../../components/TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";

const Notesheet = ({ notingRemarksData, formData, caption, logoUrl, nameOfDepartment }) => {
  console.log("formdataforPFAR", formData, notingRemarksData);

  const sortDataWithTime = (data) => {
    const sortedData = Array.isArray(data) ? [...data].sort((a, b) => a.auditDetails.lastModifiedTime - b.auditDetails.lastModifiedTime) : [];
    return sortedData;
  };

  return (
    <div className="notesheet">
      {/* Header Section */}
      {/* <header className="notesheet-header">
        <div class="logo">
          <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="Logo" class="logo-image" />
        </div>
        <div className="authority-name">
          <h1>GKP Development Authority</h1>
          <h2>NOTESHEET</h2>
        </div>
      </header> */}
      <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img width="60" height="30" src={logoUrl} alt="Uttar-Pradesh-Logo" />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>{nameOfDepartment}</p>
          <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>

      {/* Proposal Details Section */}
      <section class="proposal-details">
        <h3>Proposal Details</h3>
        <div class="row">
          <div class="col-6">
            <strong>File Number:</strong>
            {formData?.applicationNo}
          </div>
          <div class="col-6">
            <strong>Submitted On:</strong>
            {caption?.date}
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <strong>Application Type:</strong> {formData?.applicationType}
          </div>
          <div class="col-6">
            {" "}
            <strong>License No:</strong> {formData?.professionalInformation?.licenseNumber}
          </div>
        </div>
        {formData?.professionalInformation?.consultantCategory && (
          <div class="row">
            <div class="col-6">
              <strong>{formData?.professionalInformation?.consultantCategory}:</strong> {formData?.professionalInformation?.name}
            </div>
            <div class="col-6">
              {" "}
              <strong>{formData?.professionalInformation?.consultantCategory} Mobile:</strong>
              {formData?.professionalInformation?.mobileNumber}
            </div>
          </div>
        )}
        <div class="row">
          <div class="col-6">
            {" "}
            <strong>Owners Name:</strong> {formData?.landInfo?.owners?.[0].name}
          </div>
          <div class="col-6">
            {" "}
            <strong>Owners Mobile:</strong> {formData?.landInfo?.owners?.[0].mobileNumber}
          </div>
        </div>

        <div></div>
      </section>

      {/* Remarks Table Section */}
      <section className="remarks-table">
        <table>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Officers Name</th>
              <th>Designation</th>
              <th>Officers Remarks</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {sortDataWithTime(notingRemarksData?.SecurityReport)
              ?.reverse()
              ?.map((item, index) => {
                const date = ConvertEpochToDate(item?.auditDetails?.createdTime);
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.userName}</td>
                    <td>{item.userDesignation}</td>
                    <td>
                      {/* documentDetails */}
                      {item.detailDataRemarks?.[0]?.documentDetails?.developerRemarks && (
                        <React.Fragment>
                          <strong>Document Remarks :</strong>
                          <p>{<SafeHtml html={item.detailDataRemarks?.[0]?.documentDetails?.developerRemarks} />}</p>
                        </React.Fragment>
                      )}
                      {/* drawingsDetails*/}
                      {item.detailDataRemarks?.[0]?.drawingsDetails?.developerRemarks && (
                        <React.Fragment>
                          <strong>Drawings Remarks :</strong>
                          <p>{<SafeHtml html={item.detailDataRemarks?.[0]?.drawingsDetails?.developerRemarks} />}</p>
                        </React.Fragment>
                      )}
                      {/* inspectionDetails */}
                      {item?.detailDataRemarks?.[0]?.inspectionDetails?.inspectionReportData?.developerRemarks && (
                        <React.Fragment>
                          <strong>Inspection Remarks :</strong>
                          <p>{<SafeHtml html={item?.detailDataRemarks?.[0]?.inspectionDetails?.inspectionReportData?.developerRemarks} />}</p>
                        </React.Fragment>
                      )}
                      {/* PaymentDetails */}
                      {item.detailDataRemarks?.[0]?.paymentDetails?.developerRemarks && (
                        <React.Fragment>
                          <strong>Payment Remarks :</strong>
                          <p>{<SafeHtml html={item.detailDataRemarks?.[0]?.paymentDetails?.developerRemarks} />}</p>
                        </React.Fragment>
                      )}
                      {/* notingDetails */}
                      {item.detailDataRemarks?.[0]?.notingDetails?.developerRemarks && (
                        <React.Fragment>
                          <strong>Noting Remarks :</strong>
                          <p>{<SafeHtml html={item.detailDataRemarks?.[0]?.notingDetails?.developerRemarks} />}</p>
                        </React.Fragment>
                      )}

                      {/* <div
                    dangerouslySetInnerHTML={{
                      __html: item.comment || "No Remarks",
                    }}
                  /> */}
                    </td>
                    <td>{date}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Notesheet;
